import React from "react";

const CPP_Variables = () => {
  return (
    <div>
      <h1>CPP_Variables Component</h1>
      <p>Content for CPP_Variables goes here...</p>
    </div>
  );
};

export default CPP_Variables;
